import { cards } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            编辑精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            每周由编辑团队精心挑选的高分漫画推荐，帮你发现值得追的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 4 ? undefined : 'lazy'}
                />
                {card.hot && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-background-50">
                    HOT
                  </span>
                )}
                <span className="absolute top-3 right-3 px-2 py-0.5 text-[10px] font-medium rounded-full bg-background-50/90 text-foreground-700 backdrop-blur-sm">
                  {card.tag}
                </span>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>最新话已更新</span>
                  <span className="ml-auto flex items-center gap-1 text-primary-500">
                    <i className="ri-arrow-right-line"></i>
                    追更
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}